/**
 * Rendi Plus express activation (Figma "09 · Sheet · Rendi Plus").
 *
 * "Attiva Rendi Plus" in the Plus sheet (rendi-cart-sheets.liquid): check out
 * the Plus product on its monthly plan and bring the customer's cart back
 * afterwards. Selling plans can't ride a cart permalink, so we build a
 * SEPARATE cart via the Storefront API (cartCreate → checkoutUrl) and redirect
 * there. Needs a public Storefront token on the button (data-sf-token);
 * without it the Liquid renders a plain link instead. The card re-renders on
 * every cart merge, so we delegate on document.
 *
 * The store cart is preserved across the checkout by window.RendiCartRestore
 * (rendi-cart-restore.js, loaded first), shared with the Plus landing form so
 * both back up the cart the same way.
 */
(function () {
  'use strict';

  const CART_CREATE =
    'mutation CartCreate($lines:[CartLineInput!]!){' +
    'cartCreate(input:{lines:$lines}){cart{checkoutUrl} userErrors{field message}}}';

  function activatePlus(btn) {
    const token = btn.getAttribute('data-sf-token');
    const merchandiseId = btn.getAttribute('data-merchandise-id');
    const fallback = btn.getAttribute('data-fallback') || '/products/diventa-un-cliente-premium';
    if (!token || !merchandiseId) {
      window.location.href = fallback;
      return;
    }
    const version = btn.getAttribute('data-sf-version') || '2026-01';
    const plan = btn.getAttribute('data-selling-plan-id');
    const line = { quantity: 1, merchandiseId: merchandiseId };
    if (plan) line.sellingPlanId = plan;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    // RendiCartRestore owns the snapshot→checkout protocol (persist a backup or
    // don't start, drop the snapshot on failure): we only supply the checkout
    // (Storefront cartCreate) and the degrade-to-landing fallback.
    window.RendiCartRestore.activate({
      fallback: function () {
        window.location.href = fallback;
      },
      checkout: function () {
        return fetch(window.location.origin + '/api/' + version + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Shopify-Storefront-Access-Token': token,
          },
          body: JSON.stringify({ query: CART_CREATE, variables: { lines: [line] } }),
        })
          .then(function (res) { return res.json(); })
          .then(function (json) {
            const created = json && json.data && json.data.cartCreate;
            const url = created && created.cart && created.cart.checkoutUrl;
            if (!url) throw new Error('cartCreate: no checkoutUrl');
            window.location.href = url;
          });
      },
    });
  }

  function init() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      const plusBtn = e.target.closest('[data-rendi-plus-activate]');
      if (plusBtn) {
        e.preventDefault();
        activatePlus(plusBtn);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
